module.exports = __webpack_public_path__ + "img/emp_icon.f2808aa7.png";